// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as PlusDefault } from '../../../../../ui-v3/src/assets/icons/default/general/plus.svg?react';
import { ReactComponent as PlusSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/PLUS.svg?react';
import { createIcons } from '../../Icon';
const PlusIcon = /* @__PURE__ */ createIcons('Plus', {
    default: PlusDefault,
    solid: PlusSolid
});
PlusIcon.supportedTypes = [
    'default',
    'solid'
];
PlusIcon.category = 'general';
export default PlusIcon;
